export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_RETARD_PAIEMENT_LASTDATAFROMLOAD = 'SET_RETARD_PAIEMENT_LASTDATAFROMLOAD';
